export const translations = {
  status: {
    id: "vehicle.single.registry.upload.conclusion.status",
    defaultMessage: "Conclusion",
  },
  title: {
    id: "vehicle.single.registry.upload.conclusion.title",
    defaultMessage: "Import completed!",
  },
  subtitle: {
    id: "vehicle.single.registry.upload.conclusion.subtitle",
    defaultMessage: "Your additions and updates are now available in GoHub.",
  },
  itemsChanged: {
    id: "vehicle.single.registry.upload.conclusion.itemsChanged",
    defaultMessage:
      "{items, plural, one {# item changed} other {# items changed}}",
  },
  nextStepTitle: {
    id: "vehicle.single.registry.upload.conclusion.nextStep.title",
    defaultMessage: "Next step:",
  },
  nextStepDescription: {
    id: "vehicle.single.registry.upload.conclusion.nextStep.description",
    defaultMessage:
      "Now we will synchronize the vehicles with other selected Edenred solutions. Track the status {link}.",
  },
  nextStepLinkText: {
    id: "vehicle.single.registry.upload.conclusion.nextStep.linkText",
    defaultMessage: "here",
  },
};
